module.exports = __webpack_public_path__ + "img/logo.26b11da3.png";